<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Lucide from "@/components/Base/Lucide";
import PageTitle from "@template/components/PageTitle/PageTitle.vue";

const { t } = useI18n();
const route = useRoute();

const titleKey = computed(() => (route.meta.titleKey as string) || "menu.section_management");
const subtitleKey = computed(
  () => (route.meta.subtitleKey as string) || "comingSoon.default_subtitle"
);
const icon = computed(() => (route.meta.icon as string) || "Construction");
</script>

<template>
  <div class="mt-8">
    <PageTitle :title="t(titleKey)" :subtitle="t('comingSoon.badge')" :icon="icon" variant="slate" />

    <div class="box box--stacked mt-6 max-w-2xl p-8 text-center">
      <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-500">
        <Lucide :icon="icon" class="h-7 w-7" />
      </div>
      <h2 class="mt-4 text-lg font-medium text-slate-800">{{ t("comingSoon.title") }}</h2>
      <p class="mt-2 text-sm text-slate-500 leading-relaxed">
        {{ t(subtitleKey) }}
      </p>
    </div>
  </div>
</template>
